import PropTypes from 'prop-types'
import { useId } from 'react'

import { isBlank } from 'utils'

import RadioInput from 'components/RadioInput/RadioInput'

import { Root } from './RadioInputs.style'

const RadioInputs = ({ options, value, onChange = () => {} }) => {
  const name = useId()
  if (isBlank(options)) return null

  return (
    <Root>
      {options?.map((option, index) => (
        <RadioInput key={index} {...option} name={name} checked={option.value === value} onChange={onChange} />
      ))}
    </Root>
  )
}

RadioInputs.propTypes = {
  options: PropTypes.array,
}

RadioInputs.defaultProps = {}

export default RadioInputs
